import { AppRoutes } from "./AppRoutes";

export enum SystemSettingsTab {
  Dropdowns = "dropdowns",
  SystemRelevantDropdowns = "system-relevant-dropdowns",
  Templates = "templates",
  Banners = "banners",
  ProceedingParticipants = "proceeding-participants",
  Volunteers = "volunteers",
  TranslationTool = "translation-tool",
  MailMerge = "mail-merge",
  Addresses = "addresses",
  Holidays = "holidays",
  Parameters = "parameters",
  AmsParameters = "ams-parameters",
  Courts = "courts",
  Counselors = "counselors",
}

export enum SystemSettingsTemplateTab {
  Sms = "sms",
  CaseNote = "aktenvermerke",
  Email = "emails",
}

export enum SystemSettingsCourtsTab {
  Vienna = "vienna",
}

export enum CounselorRoutes {
  ById = ":id",
}

export enum SystemSettingsCounselorTab {
  PersonalData = "personal-data",
  WorkTime = "work-time",
  DutyPreferences = "duty-preferences",
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type CounselorByIdParams = {
  id: string;
};

export enum VolunteerRoutes {
  ById = ":id",
}

export enum SystemSettingsVolunteerTab {
  PersonalData = "personal-data",
  AssignedClients = "assigned-clients",
  Access = "access",
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type VolunteerByIdParams = {
  id: string;
};

export const systemSettingsPath = {
  byTab: (tab: SystemSettingsTab) => `${AppRoutes.SystemSettings}/${tab}`,
  byTemplateTab: (tab: SystemSettingsTemplateTab) =>
    `${AppRoutes.SystemSettings}/${SystemSettingsTab.Templates}/${tab}`,
  byCounselorId: (params: CounselorByIdParams) =>
    `${AppRoutes.SystemSettings}/${SystemSettingsTab.Counselors}/${params.id}`,
  byCounselorTab: (params: CounselorByIdParams & { tab: SystemSettingsCounselorTab }) =>
    `${AppRoutes.SystemSettings}/${SystemSettingsTab.Counselors}/${params.id}/${params.tab}`,
  byVolunteerId: (params: VolunteerByIdParams) =>
    `${AppRoutes.SystemSettings}/${SystemSettingsTab.Volunteers}/${params.id}`,
  byVolunteerTab: (params: VolunteerByIdParams & { tab: SystemSettingsVolunteerTab }) =>
    `${AppRoutes.SystemSettings}/${SystemSettingsTab.Volunteers}/${params.id}/${params.tab}`,
};
